import { render, staticRenderFns } from "./Issuescan.vue?vue&type=template&id=6fb1bc14&scoped=true"
import script from "./Issuescan.vue?vue&type=script&lang=js"
export * from "./Issuescan.vue?vue&type=script&lang=js"
import style0 from "./Issuescan.vue?vue&type=style&index=0&id=6fb1bc14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb1bc14",
  null
  
)

export default component.exports